module.exports = __webpack_public_path__ + "img/F-huset.b14f59a6.jpg";